import { allRequestsHaveCompleted } from '@ane/core/lib/models';
export const getDraftWorkspaceDictionaryKey = ({ workspaceId, metricSetName, draftName, }) => `${workspaceId}_${metricSetName}_${draftName}`;
export const getDraftExperimentationGroupDictionaryKey = ({ experimentationGroupId, metricSetName, draftName, }) => `${experimentationGroupId}_${metricSetName}_${draftName}`;
export const hasWriteAccessSelector = ({ workspaceId, metricSetName, draftName }, state) => {
    var _a;
    return (_a = state.maui.global.user_metric_write_access[getDraftWorkspaceDictionaryKey({
        workspaceId,
        metricSetName,
        draftName,
    })]) === null || _a === void 0 ? void 0 : _a.data;
};
export const hasScorecardLayoutSelector = (state) => { var _a; return allRequestsHaveCompleted(state.maui.draft.scorecard_layouts.status) ? !!((_a = state.maui.draft.scorecard_layouts.data) === null || _a === void 0 ? void 0 : _a.length) : true; };

//# sourceMappingURL=CheckUserAccess.selectors.js.map
